export enum APValidationTypes {
    LIVENESS = 1,
}